import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponCheckRequestBody, CouponCheckResponse } from "./types";

export class CouponCheckAPI extends BaseAPI<
  CouponCheckRequestBody,
  CouponCheckResponse
> {
  protected route = ApiRoutes.coupon.check;
  protected method = RequestMethod.PUT;
}
